<template>
    <section class='viewsrhqyBaseManagecomponents_baseModal'>
        <el-dialog :title="title" :visible.sync="visible" width="680px">
            <div class="pr-20">
                <el-form ref="form" :model="form" label-width="150px" :rules="rules">
                    <el-form-item label="基地名称" prop="name">
                        <el-input v-model.trim="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="排序" prop="idx">
                        <el-input v-model.number="form.idx"></el-input>
                    </el-form-item>
                    <el-form-item label="基地编码" prop="code">
                        <el-input v-model.trim="form.code"></el-input>
                    </el-form-item>
                    <el-form-item label="木片的送货预约方式" prop="booking_type">
                        <el-radio-group v-model="form.booking_type">
                            <el-radio :label="1">发货打卡+预约送货</el-radio>
                            <el-radio :label="2">仅发货打卡</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
                            v-model="form.remark"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="visible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="onOk">确 定</el-button>
            </span>
        </el-dialog>
    </section>
</template>
<script>
import { cloneDeep } from 'lodash'
export default {
    data() {
        return {
            visible: false,
            form: {},
            rules: {
                name: [
                    { required: true, message: '请输入基地名称', trigger: 'blur' }
                ],
                idx: [
                    { required: true, message: '请输入排序', trigger: 'blur' },
                    { pattern: /^\d+$/, message: '请输入正确的排序', trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入编码', trigger: 'blur' }
                ],
                booking_type: [
                    { required: true, message: '请选择木片的送货预约方式', trigger: 'change' }
                ],
            }
        };
    },
    computed: {
        title() {
            return this.form.id ? "修改基地" : "新建基地";
        }
    },
    methods: {
        openModal(row) {
            if (row) {
                this.form = cloneDeep(row);
            }
            this.visible = true;
            this.form = {};
        },
        onOk() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    const url = this.form.id ? "/api/contact/update_coordinate" : "/api/contact/create_coordinate";
                    this.$common.http({
                        url,
                        data: this.form
                    }).then(() => {
                        this.$message.success(`${this.form.id? "修改" : "添加"}成功`);
                        this.visible = false;
                        this.$emit("ok");
                    })
                }
            })
        }
    }
}

</script>